// extracted by mini-css-extract-plugin
module.exports = {"list":"Timeline_list__PCv6v"};